// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__4RHAZ","info":"PatientInfo_info__2nN-_"};